import { CanActivateFn, Router } from "@angular/router";
import { BreakpointService } from "../services/breakpoint.service";
import { inject } from "@angular/core";

export function mobileGuard(): CanActivateFn {
    return () => {
      const breakpointService: BreakpointService = inject(BreakpointService);
      const routerService: Router = inject(Router);

      if (breakpointService.isMobile) {
        return true;
      }

      routerService.navigate(['/home']);
      return false;
    };
  }